// extracted by mini-css-extract-plugin
export default {"container":"TestimonialItem_container__BBh1u","name":"TestimonialItem_name__Qe4oO","text":"TestimonialItem_text__tZLm4","stars":"TestimonialItem_stars__FSjXy"};